module.exports = __webpack_public_path__ + "static/media/arrow-up.097c9eec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow-up.svg
// module id = 51
// module chunks = 0